import { ComponentPropsWithoutRef } from 'react';

export enum ThemesScrollBar {
  primary = 'primary',
  gray = 'gray',
}

export interface PropsScrollBar extends ComponentPropsWithoutRef<'div'> {
  getContainerRef?: (blockRef) => void;
  maxH?: number;
  maxW?: number;
  hide?: boolean;
  type: 'horizontal' | 'vertical';
  classContainer?: string;
  classScrollBar?: string;
  classWrapper?: string;
  theme?: ThemesScrollBar;
}
